var beaconLoaded = false;

function isEnglish() {
  return document.documentElement.lang.startsWith("en") || location.pathname.startsWith("/en/");
}

function ensureBeacon() {
  if (beaconLoaded) return;
  beaconLoaded = true;

  window.Beacon = function (t, n, a) {
    window.Beacon.readyQueue.push({ method: t, options: n, data: a });
  };
  window.Beacon.readyQueue = [];

  var s = document.createElement("script");
  s.async = true;
  s.src = "https://beacon-v2.helpscout.net";
  document.head.appendChild(s);

  window.Beacon("init", "aff63f47-4116-456a-9625-1d75ad85f2ed");
}

var interactionEvents = ["scroll", "mousemove", "touchstart", "keydown"];
function onFirstInteraction() {
  ensureBeacon();
  interactionEvents.forEach(function (ev) {
    window.removeEventListener(ev, onFirstInteraction);
  });
}
interactionEvents.forEach(function (ev) {
  window.addEventListener(ev, onFirstInteraction, { passive: true });
});

document.addEventListener("click", function (e) {
  if (e.target.closest("[data-beacon-open]")) {
    e.preventDefault();
    ensureBeacon();
    window.Beacon("open");
    return;
  }

  if (e.target.closest("[data-beacon-referral]")) {
    e.preventDefault();
    ensureBeacon();
    window.Beacon("open");
    window.Beacon("navigate", "/ask/message/");
    window.Beacon("prefill", isEnglish() ? {
      subject: "Referral programme sign-up",
      text: "Hi! I'd like to sign up for the 20Tabs referral programme.\n\nMy name:\nMy email address:\nMy phone number:\n\nA quick note on how I plan to refer 20Tabs:",
    } : {
      subject: "Aanmelding referral programma",
      text: "Hoi! Ik wil mij aanmelden voor het 20Tabs referral programma.\n\nMijn naam:\nMijn e-mailadres:\nMijn telefoonnummer:\n\nKort over hoe ik 20Tabs wil doorverwijzen:",
    });
    return;
  }

  if (!e.target.closest("[data-beacon-demo]")) return;

  e.preventDefault();
  ensureBeacon();
  window.Beacon("open");
  window.Beacon("navigate", "/ask/message/");
  window.Beacon("prefill", isEnglish() ? {
    subject: "Request a demo",
    text: "Hi! I'm interested in a demo of 20Tabs. Could you get in touch with me?",
  } : {
    subject: "Demo aanvragen",
    text: "Hoi! Ik ben geïnteresseerd in een demo van 20Tabs. Kunnen jullie contact met mij opnemen?",
  });
});
